// Navbar.jsx

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import LanguageSwitcher from "./switch";
import { useTranslation } from "react-i18next";
import Button from "@/components/shared/Button";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { t, i18n } = useTranslation();

  const isEnglish = i18n.language === "en";

  const navItems = [
    { path: "#home", label: t("home") },
    { path: "#features", label: t("features") },
    { path: "#services", label: t("services") },
    { path: "#testimonials", label: t("testimonials") },
    { path: "#pricing", label: t("pricing.badge") },
    { path: "#faq", label: t("faq.title") },
    { path: "#contact", label: t("contact") },
  ];

  return (
    <>
      <nav className="absolute top-0 left-0 z-50 w-full px-4 py-4 lg:px-12 xl:px-16">
        <div className="bg-tertiary/50 flex items-center justify-between rounded-3xl border border-transparent px-4 py-2 shadow-lg backdrop-blur-sm transition duration-300">
          {/* Logo */}
          <a
            href="#home"
            aria-label="Go to homepage"
            className="text-primary flex items-center space-x-2 text-xl font-bold xl:text-4xl"
          >
            <img
              src="/assets/logos/logo-nizam.svg"
              alt="Nizam Logo"
              className="h-10 w-[120px] object-contain md:h-12 md:w-[150px]"
            />

            <span className="hidden text-xl md:inline-block">{t("nizam")}</span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden font-medium transition duration-200 xl:flex">
            {navItems.map(({ path, label }) => (
              <a
                key={path}
                href={path}
                className="text-dark hover:text-primary px-6 transition duration-200"
              >
                {label}
              </a>
            ))}
          </div>

          {/* Right Side */}
          <div
            className={`hidden items-center space-x-4 xl:flex ${
              isEnglish ? "w-[230px]" : ""
            }`}
          >
            <LanguageSwitcher />

            <Button url="#contact" size="md">
              {t("freeTrial")}
            </Button>
          </div>

          {/* Mobile Toggle Button */}
          <button
            className="text-primary relative z-50 text-4xl xl:hidden"
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? "Close menu" : "Open menu"}
          >
            {isOpen ? <HiOutlineX /> : <HiOutlineMenu />}
          </button>
        </div>
      </nav>

      {/* Mobile Overlay */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          className="fixed inset-0 z-40 flex items-center justify-center bg-black/30 backdrop-blur-md xl:hidden"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-11/12 max-w-sm space-y-6 p-6 text-center"
          >
            <div className="mb-6 flex flex-col items-center gap-4">
              <LanguageSwitcher />

              <Button url="#contact" size="sm">
                {t("freeTrial")}
              </Button>
            </div>

            {navItems.map(({ path, label }) => (
              <a
                key={path}
                href={path}
                onClick={() => setIsOpen(false)}
                className="text-dark hover:text-primary block text-2xl font-semibold transition hover:underline"
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
